module.exports = __webpack_public_path__ + "static/img/scss.17d4306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/scss.png
// module id = FKKB
// module chunks = 1